export interface ModuleData {
  id: string;
  title: string;
  ageGroup: string;
  narrativeHook: string;
  techStack: string[];
  hardware: string[];
  deliverable: string;
  qefQuantitative: string;
  qefQualitative: string;
}

export const modulesData: ModuleData[] = [
  {
    id: "space-education",
    title: "Space Education & Data Science",
    ageGroup: "Ages 14-18",
    narrativeHook: "Transform your classroom into mission control. Students analyze real satellite data and design space habitats using advanced AI, preparing them for the booming aerospace industry.",
    techStack: ["Python", "TensorFlow", "Generative AI (Spatial Design)", "Data Visualization"],
    hardware: ["High-Performance Laptops", "VR Headsets (Optional)", "Microcontrollers"],
    deliverable: "A comprehensive data analysis report on exoplanet habitability and a 3D-modeled space settlement prototype.",
    qefQuantitative: "85% of students demonstrate proficiency in basic Python data analysis; 100% complete a capstone project.",
    qefQualitative: "Enhanced critical thinking, spatial reasoning, and understanding of complex datasets in real-world contexts."
  },
  {
    id: "drone-missions",
    title: "The Low-Altitude Economy: Drone Missions",
    ageGroup: "Ages 12-18",
    narrativeHook: "Equip students for the future of logistics and surveillance. They will program autonomous drone flight paths and use computer vision to analyze aerial data.",
    techStack: ["Python", "OpenCV", "Flight Control Software", "Block-based Coding"],
    hardware: ["Programmable Drones", "Camera Modules", "Safety Enclosures"],
    deliverable: "An autonomous drone mission that successfully navigates an obstacle course and identifies specific ground targets.",
    qefQuantitative: "90% of students successfully program a multi-waypoint autonomous flight; 80% implement basic object detection.",
    qefQualitative: "Improved spatial awareness, algorithmic thinking, and understanding of aviation safety and ethics."
  },
  {
    id: "vibe-coding",
    title: "CreaTech AI Prompt Lab: Vibe Coding",
    ageGroup: "Ages 7-18",
    narrativeHook: "Unlock the creative potential of generative AI. Students learn to craft precise prompts to generate art, music, and stories, blending technology with artistic expression.",
    techStack: ["Midjourney / DALL-E", "ChatGPT / Claude", "AI Music Generators", "Digital Art Tools"],
    hardware: ["Tablets or Chromebooks", "Drawing Tablets (Optional)"],
    deliverable: "A multimedia digital portfolio featuring AI-assisted artwork, a short story, and an original soundtrack.",
    qefQuantitative: "100% of students create a portfolio with at least 3 distinct AI-generated media types.",
    qefQualitative: "Development of 'prompt engineering' skills, creative problem solving, and digital literacy."
  },
  {
    id: "iot-maker-lab",
    title: "Text-to-Object: IoT Maker Lab",
    ageGroup: "Ages 7-15",
    narrativeHook: "Bridge the digital and physical worlds. Students use AI to generate 3D models from text descriptions, then bring them to life with 3D printing and IoT sensors.",
    techStack: ["Text-to-3D AI", "Tinkercad / Fusion 360", "Arduino / Micro:bit IDE"],
    hardware: ["3D Printers", "Micro:bit or Arduino Kits", "Various Sensors (Temp, Light, Motion)"],
    deliverable: "A functional, 3D-printed smart device that responds to environmental stimuli.",
    qefQuantitative: "95% of students successfully print a 3D object; 85% integrate at least one working sensor.",
    qefQualitative: "Hands-on experience with rapid prototyping, understanding of IoT concepts, and iterative design thinking."
  },
  {
    id: "tech-entrepreneurship",
    title: "Young CEO: Tech Entrepreneurship",
    ageGroup: "Ages 12-18",
    narrativeHook: "Empower the next generation of innovators. Students identify real-world problems, develop tech-based solutions, and pitch their startup ideas to a panel of 'investors'.",
    techStack: ["No-Code App Builders", "AI Market Research Tools", "Presentation Software"],
    hardware: ["Laptops or Tablets"],
    deliverable: "A functional app prototype, a comprehensive business plan, and a polished pitch deck.",
    qefQuantitative: "100% of teams develop a working prototype; 90% deliver a complete pitch presentation.",
    qefQualitative: "Fostering entrepreneurial mindset, public speaking skills, teamwork, and business acumen."
  },
  {
    id: "digital-heritage",
    title: "Digital Heritage & Intergenerational Co-creation",
    ageGroup: "Ages 12-18",
    narrativeHook: "Preserve history through technology. Students collaborate with elders to digitize local heritage, creating interactive AR experiences and digital archives.",
    techStack: ["AR Development Platforms (e.g., Spark AR)", "Photogrammetry Software", "Audio/Video Editing"],
    hardware: ["Smartphones/Tablets with AR capabilities", "360 Cameras (Optional)", "Audio Recording Gear"],
    deliverable: "An interactive AR exhibition showcasing digitized local history and oral histories.",
    qefQuantitative: "Each student digitizes at least 3 historical artifacts/stories; 100% participate in the final exhibition.",
    qefQualitative: "Enhanced empathy, historical awareness, community engagement, and digital storytelling skills."
  }
];
